import PropTypes from 'prop-types'
import ConsignmentInboundRequestCellService from './consignment-inbound-request-table-cell-service'
import { Badge } from 'reactstrap'

const propTypes = {
  inboundRequest        : PropTypes.object,
  inboundRequestColumns : PropTypes.array,
  sellerColumns         : PropTypes.array,
  onClickRow            : PropTypes.func
}

const defaultProps = {
  inboundRequest        : {},
  inboundRequestColumns : [],
  sellerColumns         : [],
  onClickRow            : () => { }
}

/**
 * Component to display each ::Consignment::InboundRequest data in ConsignmentInboundRequest
 * @param {Object} inboundRequest - ::Consignment::InboundRequest
 * @param {Array} inboundRequestColumns - Array of displayed consignmentInboundRequestColumns column section
 * @param {Array} sellerColumns - Array of displayed seller column section
 * @param {Function} onClickRow - function that trigger when user click row data
 */

const ConsignmentInboundRequestTableRow = ({
  inboundRequest,
  inboundRequestColumns,
  sellerColumns,
  onClickRow
}) => {
  const inboundCellData = ConsignmentInboundRequestCellService.generateInboundCellData(inboundRequest)
  return (
    <tr onClick={ () => onClickRow (inboundRequest.id) }>
      {
        inboundRequestColumns.map((data) => (
          <td
            key={ `inbound-request-${inboundRequest.id}-${data.name}` }
            style={ inboundCellData[ data.name ]?.style }
          >
            {
              inboundRequest[data.name]
                ? inboundCellData[ data.name ]?.content
                : (
                  <Badge pill color='danger'>{ '-' }</Badge>
                )
            }
          </td>
        ))
      }
      {
        sellerColumns.map((data) => (
          <td key={ `inbound-data-${inboundRequest.id}-${data.name}` } style={ inboundCellData[data.name]?.style }>
            { inboundCellData[data.name]?.content }
          </td>
        ))
      }
    </tr>
  )
}

ConsignmentInboundRequestTableRow.propTypes    = propTypes
ConsignmentInboundRequestTableRow.defaultProps = defaultProps

export default ConsignmentInboundRequestTableRow